import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

/** @throws {Error} if used outside the pull requests layout route. */
export function useLayoutQueryKey() {
  const queryKey = useRouteQueryKey(pullRequestsLayoutRoute, 'mainQuery')

  if (!queryKey) throw new Error('Pull requests layout route is not mounted')
  return queryKey
}

export function useLayoutQuery() {
  return useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
}
